__webpack_require__.p = "/word-scramble/";